<script>
  export let name;
  export let position;
  export let imageUrl;
  export let description;
  export let gradientType = 1; //This determines which gradient is used so it doesn't look bland

  let showEgg = name === "Joshua Zheng";
  let eggClicked = false;
</script>

<div class="card-container">
  <div
    class="officer-card
  {gradientType === 1
      ? 'gradient-type-1'
      : gradientType === 2
        ? 'gradient-type-2'
        : 'gradient-type-3'}"
  >
    <img src={imageUrl} alt="{name}'s profile picture" />
    <h3>{name}</h3>
    <p><strong>{position}</strong></p>
    <p>{description}</p>
    {#if showEgg && !eggClicked}
      <button class="easter-egg-button" on:click={() => (eggClicked = true)}>
        🥚
      </button>
    {:else if showEgg && eggClicked}
      <p class="easter-egg-reveal">
        🥚 Found one! More are hiding—keep going. –JZ
      </p>
    {/if}
  </div>
</div>

<style>
  @keyframes slideInBottom {
    0% {
      transform: translateY(100%); /* Start from below the screen */
      opacity: 0; /* Start invisible */
    }
    100% {
      transform: translateY(0); /* End at original position */
      opacity: 1; /* End visible */
    }
  }
  .card-container {
    animation: slideInBottom 1s;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around; /* Adjust alignment as needed */
    max-width: 1200px; /* Set a max width for the container */
    margin: 0 auto; /* Centers the container */
    padding: 20px; /* Optional: Add padding for better spacing */
  }

  .officer-card {
    flex: 0 1 calc(45vw - 20px); /* Responsive width minus margins */
    max-width: 300px; /* Set a max width for each card */
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    margin: 10px;
    color: #333;
    display: flex;
    flex-direction: column; /* Aligns items vertically */
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center items horizontally */
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease,
      background-color 0.3s ease;
  }
  /* Gradient Type 1 */
  .gradient-type-1 {
    background: linear-gradient(
      to top,
      rgb(218, 101, 167),
      /* Pink at the top */ #9034c5 /* Purple at the bottom */
    );
  }

  /* Gradient Type 2 */
  .gradient-type-2 {
    background: linear-gradient(
      to top,
      #c56e34,
      /* Purple at the bottom */ rgb(218, 101, 167) /* Pink at the top */
    );
  }
  /* Gradient Type 3 */
  .gradient-type-3 {
    background: linear-gradient(
      to top,
      #9034c5,
      /* Pink at the top */ #c56e34 /* Purple at the bottom */
    );
  }
  .officer-card:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    background-color: #f0f0f0; /* Subtle change on hover */
  }

  .officer-card img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 15px;
    display: block; /* Ensure it's a block element */
    margin-left: auto; /* Center image */
    margin-right: auto; /* Center image */
  }

  .officer-card h3 {
    margin-bottom: 10px;
    color: black;
  }

  .officer-card p {
    color: white;
    margin: 5px 0;
  }
  @media only screen and (max-width: 600px) {
    :global(body) {
      overflow-x: hidden; /* Prevent horizontal scrolling */
    }
    .officer-card {
      flex: none;
    }
    .card-container {
      animation: slideInBottom 1s;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around; /* Adjust alignment as needed */
      max-width: 90vw; /* Set a max width for the container */
      margin: 0 auto; /* Centers the container */
      padding: 5vw; /* Optional: Add padding for better spacing */
    }
  }

  .easter-egg-button {
    margin-top: 10px;
    font-size: 0.8rem;
    background: transparent;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    color: rgba(255, 255, 255, 0.5);
    padding: 4px 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .easter-egg-button:hover {
    color: #ffd520;
    border-color: #ffd520;
    transform: scale(1.05);
  }

  .easter-egg-reveal {
    margin-top: 10px;
    font-size: 0.9rem;
    color: #fffbe0;
    background: rgba(255, 255, 255, 0.1);
    padding: 8px;
    border-radius: 6px;
    animation: fadeIn 0.5s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
